import { CollapsableTitle, ActionIcon } from '@celltrak/ui-components';

import { profileInfo } from '../../constants';

import ProfileViewInfo from './ProfileViewInfo';
import ProfileInfoForm from './ProfileInfoForm';
import ProfileFormActions from './ProfileFormActions';
import useProfileInfo from './ProfileInfo.hooks';
import styles from './ProfileInfo.module.scss';

const ProfileInfo = () => {
  const {
    values,
    isEditable,
    setIsEditable,
    isLoading,
    handleCancel,
    handleAgencyNameChange,
    handleToggleChange,
    handleSave,
    isSaveDisabled,
  } = useProfileInfo();

  const renderInfo = () => (
    <div className={styles.formContent}>
      <CollapsableTitle
        className={styles.collapsableTitle}
        icon="fa-regular fa-circle-info"
        title={<span className={styles.title}>Agency Details</span>}
        actions={
          <ActionIcon
            icon="fa fa-pencil"
            onClick={() => setIsEditable()}
            ariaLabel={profileInfo.profileFormEditButtonLabel}
            disabled={isEditable}
          />
        }
        hideCollapseButton
      >
        {isEditable ? (
          <ProfileInfoForm
            isLoading={isLoading}
            values={values}
            handleAgencyNameChange={handleAgencyNameChange}
            handleToggleChange={handleToggleChange}
          />
        ) : (
          <ProfileViewInfo values={values} />
        )}
      </CollapsableTitle>
      {isEditable && (
        <ProfileFormActions
          isSaveDisabled={isSaveDisabled}
          handleCancel={handleCancel}
          handleSave={handleSave}
        />
      )}
    </div>
  );

  return renderInfo();
};

export default ProfileInfo;
